export const getOperatorsForStep = (operators, step) =>
  Object.keys(operators).reduce((acc, key) => {
    acc[key] = `${operators[key]}${step}`;
    return acc;
  }, {});
